import './AlertModal.css';

const AlertModal = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  type = 'info',
  buttonText = 'OK',
  showSecondaryButton = false,
  secondaryButtonText = 'Cancel',
  onSecondaryClick,
  subtitle = ''
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'success':
        return '✅';
      default:
        return 'ℹ️';
    }
  };

  const getTitle = () => {
    if (title) return title;
    switch (type) {
      case 'error':
        return 'Error';
      case 'warning':
        return 'Warning';
      case 'success':
        return 'Success';
      default:
        return 'Information';
    }
  };

  const getSubtitle = () => {
    if (subtitle) return subtitle;
    switch (type) {
      case 'error':
        return 'An error occurred';
      case 'warning':
        return 'Please review';
      case 'success':
        return 'Operation completed';
      default:
        return 'Information message';
    }
  };

  const buttonClass = showSecondaryButton ? 'dual-buttons' : 'single-button';

  return (
    <div className="alert-modal-overlay" onClick={onClose}>
      <div className="alert-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className={`alert-modal-header ${type}`}>
          <div className="alert-modal-icon-container">
            <span className="alert-modal-icon">{getIcon()}</span>
          </div>
          <div className="alert-modal-title-container">
            <h3 className="alert-modal-title">{getTitle()}</h3>
            <p className="alert-modal-subtitle">{getSubtitle()}</p>
          </div>
        </div>
        <div className="alert-modal-body">
          <p className="alert-modal-message">{message}</p>
        </div>
        <div className={`alert-modal-footer ${buttonClass}`}>
          {showSecondaryButton && (
            <button 
              className="alert-modal-button secondary" 
              onClick={onSecondaryClick || onClose}
            >
              {secondaryButtonText}
            </button>
          )}
          <button 
            className="alert-modal-button primary" 
            onClick={onClose}
            autoFocus
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;